import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import SingleChatScreen1 from "../SingleChat/index1";
import NoData from "Components/NoData";

const ChatWindowComponent = (props: any) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { selectedCase, setShowChatList } = props;
  return (
    <>
      <Box
        sx={{
          flex: 1,
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          // Version 4: Lightweight White Glass
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          backdropFilter: "blur(10px)",
          height: "100%",
          minHeight: 0,
          overflow: "hidden",
          minWidth: 0,
        }}
      >
        {selectedCase ? (
          <>
            {isMobile && (
              <Box sx={{ p: 2, backgroundColor: "#fff", borderBottom: "1px solid rgba(0,0,0,0.05)", flexShrink: 0 }}>
                <Typography
                  variant="subtitle2"
                  sx={{ 
                    cursor: "pointer", 
                    color: "#1a237e", 
                    display: "flex", 
                    alignItems: "center",
                    fontWeight: 600
                  }}
                  onClick={() => setShowChatList(true)}
                >
                  ← Back to conversations
                </Typography>
              </Box>
            )}
            <Box sx={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column", minHeight: 0 }}>
              <SingleChatScreen1 selectedCase={selectedCase} />
            </Box>
          </>
        ) : (
          <Box sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", p: 4, textAlign: "center" }}>
            <NoData cstmMsg="Select exploring a case to view the conversation history and start chatting." />
          </Box>
        )}
      </Box>
    </>
  );
};

export default ChatWindowComponent;
